import React from 'react';
import './DappWidgets.css';

/** 数据卡片（TVL / APY / 用户数） */
export const StatCard = ({ value, label, icon }) => (
  <div className="dw-stat">
    <span className="dw-stat-icon">{icon}</span>
    <b>{value}</b>
    <span className="dw-stat-label">{label}</span>
  </div>
);

/** SVG 收益率曲线（假数据，随时间波动） */
export const YieldChart = ({ points = [42, 45, 44, 48, 52, 50, 55, 58, 56, 60, 63, 61, 66, 68] }) => {
  const W = 300, H = 90, pad = 6;
  const max = Math.max(...points), min = Math.min(...points);
  const x = (i) => pad + (i * (W - pad * 2)) / (points.length - 1);
  const y = (v) => H - pad - ((v - min) * (H - pad * 2)) / (max - min || 1);
  const line = points.map((v, i) => `${x(i)},${y(v)}`).join(' ');
  const area = `${pad},${H - pad} ${line} ${W - pad},${H - pad}`;
  return (
    <div className="dw-chart">
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none">
        <polygon points={area} fill="rgba(0,113,227,0.08)" />
        <polyline points={line} fill="none" stroke="#0071e3" strokeWidth="2" strokeLinejoin="round" />
        <circle cx={x(points.length - 1)} cy={y(points[points.length - 1])} r="3.5" fill="#0071e3" />
      </svg>
    </div>
  );
};

/** 活动进度条（名额已领/总量） */
export const ProgressBar = ({ value, max, label }) => {
  const pct = Math.min(100, (value / max) * 100);
  return (
    <div className="dw-progress">
      <div className="dw-progress-head">
        <span>{label}</span>
        <b>{pct.toFixed(1)}%</b>
      </div>
      <div className="dw-progress-track">
        <div className="dw-progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

/** 参与步骤 1-2-3 */
export const Steps = ({ steps }) => (
  <div className="dw-steps">
    {steps.map((s, i) => (
      <div className="dw-step" key={i}>
        <span className="dw-step-num">{i + 1}</span>
        <div>
          <b>{s.title}</b>
          <p>{s.desc}</p>
        </div>
      </div>
    ))}
  </div>
);

/** FAQ 折叠 */
export const Faq = ({ items }) => {
  const [open, setOpen] = React.useState(-1);
  return (
    <div className="dw-faq">
      {items.map((it, i) => (
        <div className={`dw-faq-item ${open === i ? 'on' : ''}`} key={i}>
          <button className="dw-faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
            <span>{it.q}</span>
            <span className="dw-faq-arrow">{open === i ? '−' : '+'}</span>
          </button>
          {open === i && <p className="dw-faq-a">{it.a}</p>}
        </div>
      ))}
    </div>
  );
};
